var exports = {
  "N": "Link__H3GvIl",
};

module.exports = exports;
